import type { GremlinQueryParams } from 'queries/queries-utils'

export const kubernetesQueryKeys = {
  getKubernetesTargetsKinds: (query: GremlinQueryParams) =>
    ['kubernetes/targets/kinds', query] as const
}
